declare global {
  interface Window {
    _env_?: string;
    [key: string]: unknown;
  }
}

interface WindowEnvConfig {
  DIGITAL_OPERATION_URL: string;
  XSIGHT_VERSION: string;
  AUTO_REFRESH_WHEN_VERSION_CHANGED: boolean;
  [key: string]: string | number | boolean;
}

let config: WindowEnvConfig | undefined = undefined;

const env = window["_env_"];

export const getWindowEnv = (str?: string) => {
  let envStr = (str || env) as string;
  envStr = envStr.substring(0, 27) + envStr.substring(28);
  if (config === undefined)
    config = (envStr ? JSON.parse(atob(envStr)) : {}) as WindowEnvConfig;

  return config;
};
